import React from 'react'
import { useParams } from 'react-router-dom'
import CreateListing from '../createListing'

export default function AddListing() {
  const { ownerId } = useParams();

  return (
    <>
    <div class="row">
        <div class="col">
            <div class="page-description">
                <h1>{ownerId ? 'Add Boat for Owner' : 'Add Boat'}</h1>
            </div>
        </div>
    </div>

    <CreateListing targetOwnerId={ownerId} />
    
    </>
  )
}
